import { ColorSelectorUtil, SelectedColor } from "@mcleod/common";
import { McLeodClassicIntegration } from "@mcleod/core";
import { AutogenLayoutOrderType } from "./autogen/AutogenLayoutOrderType";
import { DataSourceExecutionEvent } from "@mcleod/components";

export class OrderType extends AutogenLayoutOrderType {

    buttonOpenClassicOnClick() {
        McLeodClassicIntegration.openClassicScreen("com.tms.client.loadmaster.dsp.EntryOrderType", this.mainDataSource.activeRow.get("id"));
    }

    sourceOrderTypeAfterExecution(event: DataSourceExecutionEvent) {
        const OrderTypeID = this.mainDataSource?.activeRow?.get("id");
        event.filter.parent_row_id = OrderTypeID;
        this.panelColorDisplay.backgroundColor = this.mainDataSource?.activeRow?.get("planning_hex_color");
        this.panelColorDisplay.tooltip = this.mainDataSource?.activeRow?.get("planning_hex_color");
        // this.titleEditModeSuffix = this.mainDataSource?.activeRow?.get("descr");
    }

    buttonClearColorOnClick() {
        this.syncPlanningColor({});
    }

    async buttonColorPickerOnClick() {
        const result = await ColorSelectorUtil.promptForNumericColor();
        if (result?.hexColor && result?.numericColor) {
            this.syncPlanningColor(result);
        }
    }

    private syncPlanningColor(result: SelectedColor = {}) {
        const { colorName, hexColor, numericColor } = result;
        this.sourceOrderType.activeRow.set("planning_hex_color", hexColor);
        this.sourceOrderType.activeRow.set("planning_color", numericColor);
        this.panelColorDisplay.backgroundColor = colorName;
        this.panelColorDisplay.tooltip = hexColor;
    }
}
